import type { JSX } from 'react';
import { Outlet } from 'react-router-dom';
import { CandidateSidebar } from './CandidateSidebar';
import { CandidateHeader } from './CandidateHeader';

export function CandidateAppLayout(): JSX.Element {
  return (
    <div className="flex min-h-screen bg-background">
      <CandidateSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <CandidateHeader />
        <main className="flex-1 overflow-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
